import React, { useState } from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  Table,
  Badge
} from 'reactstrap';
import Select from 'react-select';
import Swal from 'sweetalert2';

const RecipientesManager = ({ recipientes = [], onChange, opcionesRecipientes, disabled = false, restrictMode = false, volumenTotalVisita = null }) => {
  const [nuevoRecipiente, setNuevoRecipiente] = useState({
    tipo_recipiente: '',
    unidad: 1
  });

  // Función para agregar un nuevo recipiente
  const agregarRecipiente = () => {
    if (!nuevoRecipiente.tipo_recipiente) {
      Swal.fire({
        icon: 'warning',
        title: 'Campo requerido',
        text: 'Por favor selecciona un tipo de recipiente',
        confirmButtonColor: '#dc3545'
      });
      return;
    }

    if (!nuevoRecipiente.unidad || nuevoRecipiente.unidad < 1) {
      Swal.fire({
        icon: 'warning',
        title: 'Unidad inválida',
        text: 'La unidad debe ser mayor a 0',
        confirmButtonColor: '#dc3545'
      });
      return;
    }

    const nuevosRecipientes = [...recipientes, { ...nuevoRecipiente, id: Date.now() }];
    onChange(nuevosRecipientes);
    
    // Limpiar formulario
    setNuevoRecipiente({
      tipo_recipiente: '',
      unidad: 1
    });

    Swal.fire({
      icon: 'success',
      title: 'Recipiente agregado',
      text: 'El recipiente se ha agregado correctamente',
      timer: 1500,
      showConfirmButton: false
    });
  };

  // Función para eliminar un recipiente
  const eliminarRecipiente = (index) => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción eliminará el recipiente de la lista',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        const nuevosRecipientes = recipientes.filter((_, i) => i !== index);
        onChange(nuevosRecipientes);
        
        Swal.fire({
          icon: 'success',
          title: 'Recipiente eliminado',
          text: 'El recipiente ha sido eliminado correctamente',
          timer: 1500,
          showConfirmButton: false
        });
      }
    });
  };

  // Función para editar un recipiente
  const editarRecipiente = (index, campo, valor) => {
    const nuevosRecipientes = [...recipientes];
    nuevosRecipientes[index] = {
      ...nuevosRecipientes[index],
      [campo]: valor
    };
    onChange(nuevosRecipientes);
  };

  return (
    <div className="recipientes-manager">
      {/* Sección para agregar nuevo recipiente */}
      {!restrictMode && (
      <div className="mb-4">
        <div className="d-flex align-items-center mb-3">
          <div style={{
            backgroundColor: '#28a745',
            borderRadius: '8px',
            width: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '12px'
          }}>
            <i className="fas fa-plus text-white"></i>
          </div>
          <h5 className="fw-bold mb-0" style={{ color: '#28a745' }}>Agregar Recipiente</h5>
        </div>
        
        <Card className="border-0 shadow-sm" style={{ borderRadius: '12px' }}>
          <CardBody className="p-4">
            <Row>
              <Col md={8}>
                <FormGroup>
                  <Label className="fw-semibold text-dark">
                    <i className="fas fa-cube me-2 text-success"></i>
                    Tipo de Recipiente *
                  </Label>
                  <Select
                    options={opcionesRecipientes}
                    value={opcionesRecipientes.find(opt => opt.value === nuevoRecipiente.tipo_recipiente) || null}
                    onChange={(selectedOption) => 
                      setNuevoRecipiente(prev => ({ ...prev, tipo_recipiente: selectedOption?.value || '' }))
                    }
                    placeholder="Seleccionar recipiente..."
                    isDisabled={disabled}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderRadius: '8px',
                        minHeight: '52px',
                        fontSize: '16px'
                      }),
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      option: (base) => ({
                        ...base,
                        fontSize: '16px',
                        padding: '12px 16px'
                      }),
                      placeholder: (base) => ({
                        ...base,
                        fontSize: '16px'
                      })
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Label className="fw-semibold text-dark">
                    <i className="fas fa-hashtag me-2 text-success"></i>
                    Unidades *
                  </Label>
                  <Input
                    type="number"
                    min="1"
                    value={nuevoRecipiente.unidad}
                    onChange={(e) => {
                      const value = e.target.value;
                      setNuevoRecipiente(prev => ({ 
                        ...prev, 
                        unidad: value === '' ? '' : (parseInt(value) || 1)
                      }));
                    }}
                    onBlur={(e) => {
                      if (e.target.value === '' || parseInt(e.target.value) < 1) {
                        setNuevoRecipiente(prev => ({ ...prev, unidad: 1 }));
                      }
                    }}
                    disabled={disabled}
                    className="form-control-lg"
                    style={{ borderRadius: '8px', fontSize: '16px' }}
                  />
                </FormGroup>
              </Col>
              <Col md={2} className="d-flex align-items-end">
                <FormGroup className="w-100">
                  <Button
                    color="success"
                    onClick={agregarRecipiente}
                    disabled={disabled}
                    className="w-100"
                    style={{
                      borderRadius: '8px',
                      padding: '12px',
                      fontWeight: '500',
                      boxShadow: '0 3px 10px rgba(40, 167, 69, 0.3)'
                    }}
                  >
                    <i className="fas fa-plus me-2"></i>
                    Agregar
                  </Button>
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
      )}

      {/* Lista de recipientes agregados */}
      {recipientes.length > 0 && (
        <div className="mb-4">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="d-flex align-items-center">
              <div style={{
                backgroundColor: '#17a2b8',
                borderRadius: '8px',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '12px'
              }}>
                <i className="fas fa-list text-white"></i>
              </div>
              <h5 className="fw-bold mb-0" style={{ color: '#17a2b8' }}>Recipientes Agregados</h5>
            </div>
            <Badge color="info" className="px-3 py-2" style={{ borderRadius: '8px', fontSize: '0.9em' }}>
              <i className="fas fa-box me-1"></i>
              {recipientes.length} recipiente{recipientes.length > 1 ? 's' : ''}
            </Badge>
          </div>
          
          <Card className="border-0 shadow-sm" style={{ borderRadius: '12px' }}>
            <CardBody className="p-0">
              <div className="table-responsive">
                <Table className="mb-0" style={{ borderRadius: '12px', overflow: 'hidden' }}>
                  <thead style={{ backgroundColor: '#17a2b8', color: 'white' }}>
                    <tr>
                      <th className="border-0 py-3 px-4 fw-semibold text-center align-middle" style={{ width: '10%' }}>#</th>
                      <th className="border-0 py-3 px-4 fw-semibold align-middle" style={{ width: '50%' }}>Tipo de Recipiente</th>
                      <th className="border-0 py-3 px-4 fw-semibold text-center align-middle" style={{ width: '20%' }}>Unidades</th>
                      <th className="border-0 py-3 px-4 fw-semibold text-center align-middle" style={{ width: '20%' }}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recipientes.map((recipiente, index) => {
                      const opcionSeleccionada = opcionesRecipientes.find(opt => opt.value === recipiente.tipo_recipiente);
                      return (
                        <tr key={recipiente.id || index}>
                          <td className="py-3 px-4 text-center align-middle">
                            <Badge color="primary" className="px-2 py-1" style={{ borderRadius: '6px' }}>
                              {index + 1}
                            </Badge>
                          </td>
                          <td className="py-3 px-4 align-middle">
                            <div className="d-flex align-items-center">
                              <i className="fas fa-cube me-3 text-info" style={{ fontSize: '1.2rem' }}></i>
                              <div className="flex-grow-1">
                                <div className="fw-bold" style={{ fontSize: '1rem', color: '#2c3e50' }}>{recipiente.parametrizacion_recipiente?.descripcion || recipiente.tipo_recipiente}</div>
                                {opcionSeleccionada && (
                                  <div className="text-muted mt-1" style={{ fontSize: '0.9rem', lineHeight: '1.3' }}>{opcionSeleccionada.label}</div>
                                )}
                              </div>
                            </div>
                          </td>
                          <td className="py-3 px-4 text-center align-middle">
                            {disabled ? (
                              <Badge color="success" className="px-2 py-1" style={{ borderRadius: '6px' }}>
                                <i className="fas fa-hashtag me-1"></i>
                                {recipiente.unidad}
                              </Badge>
                            ) : (
                              <Input
                                type="number"
                                min="1"
                                value={recipiente.unidad}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  editarRecipiente(index, 'unidad', value === '' ? '' : (parseInt(value) || 1));
                                }}
                                onBlur={(e) => {
                                  if (e.target.value === '' || parseInt(e.target.value) < 1) {
                                    editarRecipiente(index, 'unidad', 1);
                                  }
                                }}
                                style={{ width: '80px', borderRadius: '6px' }}
                              />
                            )}
                          </td>

                          <td className="py-3 px-4 text-center align-middle">
                            {!disabled && !restrictMode && (
                              <Button
                                color="danger"
                                size="sm"
                                outline
                                onClick={() => eliminarRecipiente(index)}
                                style={{
                                  borderRadius: '6px',
                                  width: '32px',
                                  height: '32px',
                                  padding: '0'
                                }}
                                title="Eliminar recipiente"
                              >
                                <i className="fas fa-trash"></i>
                              </Button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
        </div>
      )}

      {/* Resumen de recipientes */}
      {recipientes.length > 0 && (
        <div className="alert alert-info border-info">
          <div className="d-flex align-items-center mb-2">
            <i className="fas fa-info-circle me-2"></i>
            <strong>Resumen de la Visita</strong>
          </div>
          <div className="row g-2">
            <div className="col-md-4">
              <div className="d-flex align-items-center">
                <i className="fas fa-box me-2 text-primary"></i>
                <span><strong>Total de recipientes:</strong> {recipientes.length}</span>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex align-items-center">
                <i className="fas fa-hashtag me-2 text-success"></i>
                <span><strong>Total de unidades:</strong> {recipientes.reduce((total, r) => total + (r.unidad || 0), 0)}</span>
              </div>
            </div>
            {volumenTotalVisita !== null && (
              <div className="col-md-4">
                <div className="d-flex align-items-center">
                  <i className="fas fa-cube me-2 text-warning"></i>
                  <span><strong>Volumen total:</strong> {volumenTotalVisita} m³</span>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default RecipientesManager;